import React, { useState } from "react";
import PopupContainer from "components/PopupContainer";

import { CheckedIcon } from "components/icons";

import { socialRedirect } from "request/api";

import { Spinner } from "components/Spinner";
import { routerPath } from "router/routerPath";

type IProps = {
  open: boolean;
  onClose: () => void;
};

const SignInMarketingPopup: React.FC<IProps> = ({ open, onClose }) => {
  // Sample image data (replace with your actual image sources)
  const images = [
    {
      src: "/images/silder1.png",
      alt: "Living Room",
    },
    {
      src: "/images/silder2.png",
      alt: "Burger",
    },
    {
      src: "/images/silder3.png",
      alt: "Placeholder 1",
    },
    {
      src: "/images/silder4.png",
      alt: "Placeholder 2",
    },
    {
      src: "/images/silder5.png",
      alt: "Placeholder 2",
    },
  ];

  // Duplicate the images twice for seamless looping
  const duplicatedImages = [...images, ...images];

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSocialRedirect = () => {
    setIsLoading(true);
    socialRedirect()
      .then((res: any) => {
        setIsLoading(false);
        window.open(res?.url, "_self");
      })
      .catch((err: any) => {
        setIsLoading(false);
      });
  };

  const onRedirectURL = (path: string) => {
    window.open(`${process.env.REACT_APP_BASEURL}/en/${path}`, "_blank");
  };

  return (
    <PopupContainer open={open} onClose={onClose}>
      {/* Logo */}
      <div className="flex flex-row items-center justify-center p-[18px]">
        <img src="/icons/canvasai-logo.svg" alt="DeftGPT" />
      </div>

      {/* Heading and Subheading */}
      <div className="py-6">
        <h1 className="text-xl font-bold mb-3 text-center text-[#171717] leading-[22px]">
          Create{" "}
          <span className="underline decoration-1 decoration-[#171717]">
            marketing
          </span>{" "}
          visuals in seconds
        </h1>
        <p className="text-[#525252] mb-6 text-sm text-center leading-[18px] max-w-[271px] md:max-w-[343px] mx-auto">
          Sign in to generate professional portraits, artwork, memes and more
        </p>

        {/* Image Slider */}
        <div className="overflow-hidden my-9 min-h-[184px]">
          <div
            className="flex space-x-4 animate-slide-right animation-running"
            //   ref={imageWrapperRef}
          >
            {duplicatedImages.map((image, index) => (
              <div key={index} className="flex-1 min-w-[50%]">
                <div className="relative">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full max-h-[277px] object-cover rounded-md"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Continue with Google Button */}
        <button
          onClick={onSocialRedirect}
          className="w-full flex items-center justify-center text-xs h-9 bg-[#131314] text-white rounded-lg mb-3 font-roboto max-w-[271px] md:max-w-[343px] mx-auto"
        >
          {isLoading ? (
            <Spinner extraSmall className={{ "border-white": true }} />
          ) : (
            <>
              <img
                src="/icons/google-logo.png"
                alt="Google Icon"
                className="w-5 h-5 mr-2"
              />
              Continue with Google
            </>
          )}
        </button>

        {/* Terms and Privacy Policy */}
        <p className="text-[#737373] text-xs text-center mb-4 font-medium w-full max-w-[271px] md:max-w-[343px] mx-auto">
          By signing in, you agree to our{" "}
          <span
            // href={`${process.env.REACT_APP_BASEURL}/en/${routerPath.Terms}`}
            // target="_blank"
            // rel="noreferrer"
            onClick={() => onRedirectURL(routerPath.Terms)}
            className="text-[#4338CA] underline cursor-pointer"
          >
            Terms of Service
          </span>{" "}
          and{" "}
          <span
            // href={`${process.env.REACT_APP_BASEURL}/en/${routerPath.Privacy}`}
            // target="_blank"
            // rel="noreferrer"
            onClick={() => onRedirectURL(routerPath.Privacy)}
            className="text-[#4338CA] underline cursor-pointer"
          >
            Privacy Policy
          </span>
        </p>
      </div>

      <div className="border-t-[0.8px] border-dashed border-[#4338CA] p-[18px] flex flex-col items-start">
        {/* Free Plan Info */}
        <div className="flex items-center justify-center space-x-4">
          <div className="h-7 w-7 flex flex-row items-center justify-center bg-[#DCFCE7] rounded-full flex-shrink-0 text-[#2CAB58]">
            <CheckedIcon />
          </div>
          <p className="text-[#171717] text-base font-medium flex flex-col">
            <span className="leading-[18px]">
              Free plan includes 3 image generations per day
            </span>
            <span className="text-[#737373] text-xs mt-1">
              No credit card required
            </span>
          </p>
        </div>
      </div>
    </PopupContainer>
  );
};

export default SignInMarketingPopup;
